import { invariant } from "@holigral/shared/utils"
import { REALTIME_HEADER } from "./model"

export default (response: Response) => {
  const header = response.headers.get(REALTIME_HEADER)
  invariant(header, "Missing Realtime header")

  const [channel, event] = header.split(":")
  invariant(channel, "Unable to parse channel from Realtime header")
  invariant(event, "Unable to parse event from Realtime header")

  return [channel, event] as const
}
